import { FC } from "react";
import { CountryOnboardingRequestDto } from "../../../api/Api";
import { MyOnboardingRequestsGrid } from "../../../components/onboardingRequests/myRequestsGrid";
import { OnboardingRequestBook } from "../../../components/onboardingRequests/types";
import { useMyCountryOnboardingRequests } from "../../admin/countryOnboardingRequests/queries";

const countryBook: OnboardingRequestBook<CountryOnboardingRequestDto> = {
  entityLabel: "Country",
  entityName: (row) => row.payload?.countryName ?? "",
  resultingEntityId: (row) => row.resultingCountryId,
  entityPath: (id) => `/countries/country/${id}`
};

export const MyCountryRequests: FC = () => (
  <MyOnboardingRequestsGrid
    book={countryBook}
    useMyRequests={useMyCountryOnboardingRequests}
  />
);
